import { BreadcrumbTypeEnum } from '../../common/enum'
import { TranslationFunction } from '../../common/types'
import AdvancedBreadcrumbTransport from '../../transports/common/advanced-breadcrumb-transport'

export interface FormattedBreadcrumbTransport {
    title: string
    url: string
}

export class Breadcrumb {
    private readonly label?: string
    private readonly link?: string
    private readonly isRegionLink: boolean
    private readonly type: BreadcrumbTypeEnum

    constructor(type: BreadcrumbTypeEnum, label?: string, link?: string, isRegionLink = false) {
        this.label = label
        this.link = link
        this.isRegionLink = isRegionLink
        this.type = type
    }

    public getIsRegionLink(): boolean {
        return this.isRegionLink
    }

    public format(translationFunction: TranslationFunction, exposeLabel: string): FormattedBreadcrumbTransport {
        let title: string
        let url: string | undefined

        switch (this.type) {
            case BreadcrumbTypeEnum.HOME: {
                title = this.label ?? translationFunction('homePage')
                url = this.link ?? '/'
                break
            }
            case BreadcrumbTypeEnum.EXPOSE_LABEL: {
                title = this.label ?? exposeLabel
                url = this.link ?? ''
                break
            }
            default: {
                title = this.label ?? 'N/A' // This case should never happen add more implementations if needed
                url = this.link ?? ''
                break
            }
        }

        return {
            title,
            url,
        }
    }
}

export interface BreadcrumbListTransport {
    format(breadcrumbs: AdvancedBreadcrumbTransport[], exposeLabel: string): FormattedBreadcrumbTransport[]

    getLastRegionLink(
        breadcrumbs: AdvancedBreadcrumbTransport[],
        exposeLabel: string,
    ): FormattedBreadcrumbTransport | null
}

export class BreadcrumbList {
    private readonly __: TranslationFunction

    constructor(translationFunction: TranslationFunction) {
        this.__ = translationFunction
    }

    format(breadcrumbs: AdvancedBreadcrumbTransport[] = [], exposeLabel: string): FormattedBreadcrumbTransport[] {
        return breadcrumbs.map(b => {
            const breadcrumb = new Breadcrumb(b.type, b.label, b.link, b.isRegionLink)
            return breadcrumb.format(this.__, exposeLabel)
        })
    }

    public getLastRegionLink(
        breadcrumbs: AdvancedBreadcrumbTransport[],
        exposeLabel: string,
    ): FormattedBreadcrumbTransport | null {
        for (let i = breadcrumbs.length - 1; i >= 0; i--) {
            const breadcrumb = new Breadcrumb(
                breadcrumbs[i].type,
                breadcrumbs[i].label,
                breadcrumbs[i].link,
                breadcrumbs[i].isRegionLink,
            )

            if (breadcrumb.getIsRegionLink()) {
                return breadcrumb.format(this.__, exposeLabel)
            }
        }
        return null
    }
}
